/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { Fade } from "react-awesome-reveal";
import { useLocation } from "react-router-dom";
import { ChevronDownIcon } from "@heroicons/react/solid";

import Button from "../elements/Button";
import BrandIcon from "./BrandIcon";

export default function Header() {
  const [isCollapse, setIsCollapse] = useState(false);
  const location = useLocation();
  const path = location.pathname;
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const dropdownTimeout = React.useRef();

  const servicesLinks = [
    {
      label: "Core Service Lines & Revenue Streams",
      href: "/services/core-service-lines-and-revenue-streams",
    },
    {
      label: "Technology Infrastructure",
      href: "/services/technology-infrastructure",
    },
    {
      label: "Target Market Segment",
      href: "/services/target-market-segment",
    },
    {
      label: "Competitive Advantages",
      href: "/services/competitive-advantages",
    },
    {
      label: "Business Structure",
      href: "/services/business-structure",
    },
    {
      label: "Marketing & Client Acquisition Strategy",
      href: "/services/marketing-and-client-acquisition-strategy",
    },
    {
      label: "Sample Revenue Forecast",
      href: "/services/sample-revenue-forecast",
    },
    {
      label: "Legal & Compliance",
      href: "/services/legal-and-compliance",
    },
  ];

  // Dropdown open/close handlers with delay to prevent flicker
  const handleDropdownEnter = () => {
    if (dropdownTimeout.current) clearTimeout(dropdownTimeout.current);
    setServicesDropdown(true);
  };

  const handleDropdownLeave = () => {
    dropdownTimeout.current = setTimeout(() => setServicesDropdown(false), 150);
  };

  const handleDropdownLinkClick = () => {
    setServicesDropdown(false);
    setIsCollapse(false); // Close mobile menu on link click
  };

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isCollapse) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isCollapse]);

  // Close mobile menu on route change
  useEffect(() => {
    setIsCollapse(false);
    setServicesDropdown(false);
  }, [path]);

  return (
    <>
      <header className="relative z-50 bg-white shadow-sm header">
        <div className="flex items-center justify-between px-4 py-3 lg:px-0">
          <BrandIcon />
          <button
            className="block transition-transform duration-200 text-theme-blue lg:hidden focus:outline-none hover:scale-110"
            onClick={() => setIsCollapse(!isCollapse)}
            aria-label="Toggle navigation menu"
          >
            <svg
              className="w-7 h-7"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                className={`transition-opacity duration-200 ${
                  isCollapse ? "opacity-0" : "opacity-100"
                }`}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              />
              <path
                className={`transition-opacity duration-200 ${
                  !isCollapse ? "opacity-0" : "opacity-100"
                }`}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
                style={{ position: "absolute" }}
              />
            </svg>
          </button>
        </div>

        {/* Desktop Navigation */}
        <ul className="flex-row items-center hidden mt-0 tracking-widest lg:flex text-theme-blue">
          <li>
            <Button
              className={`${
                path === "/" ? "active-link" : ""
              } font-medium text-lg px-5 no-underline hover:underline transition-colors duration-200`}
              type="link"
              href="/"
            >
              Home
            </Button>
          </li>
          <li className="py-2 lg:py-0">
            <Button
              className={`${
                path === "/team" ? "active-link" : ""
              } font-medium text-lg px-5 no-underline hover:underline transition-colors duration-200`}
              type="link"
              href="/team"
            >
              About
            </Button>
          </li>
          <li className="py-2 lg:py-0" style={{ position: "relative" }}>
            <div
              onMouseEnter={handleDropdownEnter}
              onMouseLeave={handleDropdownLeave}
              style={{ display: "inline-block", width: "100%" }}
            >
              <Button
                className={`${
                  path.startsWith("/services") ? "active-link" : ""
                } font-medium text-lg px-5 no-underline hover:underline flex items-center transition-colors duration-200`}
                type="link"
                onClick={() => setServicesDropdown(!servicesDropdown)}
              >
                Services
                <ChevronDownIcon
                  className={`w-4 h-4 ml-1 transition-transform duration-200 ${
                    servicesDropdown ? "rotate-180" : ""
                  }`}
                />
              </Button>
              <div
                className={`absolute left-0 z-20 w-72 mt-2 bg-white rounded-xl shadow-xl border border-gray-100 transition-all duration-300 transform ${
                  servicesDropdown
                    ? "opacity-100 translate-y-0 visible"
                    : "opacity-0 -translate-y-2 invisible"
                }`}
              >
                <ul className="z-50 py-3">
                  {servicesLinks.map((item, index) => (
                    <li key={item.href}>
                      <Button
                        className="block w-full px-6 py-3 text-sm text-left text-gray-700 transition-all duration-200 hover:bg-gradient-to-r hover:from-purple-50 hover:to-blue-50 hover:text-theme-purple"
                        type="link"
                        href={item.href}
                        onClick={handleDropdownLinkClick}
                      >
                        {item.label}
                      </Button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </li>
          <li className="py-2 lg:py-0">
            <Button
              className={`${
                path === "/contact" ? "active-link" : ""
              } font-medium text-lg px-5 no-underline hover:underline transition-colors duration-200`}
              type="link"
              href="/contact"
            >
              Contact
            </Button>
          </li>
          <li>
            <Button
              className="px-6 py-2 mx-auto ml-3 text-lg font-medium text-white transition duration-300 border-2 border-purple-800 rounded-full bg-theme-purple border-theme-purple hover:bg-dark-theme-purple hover:shadow-lg hover:scale-105"
              type="link"
              href="/contact"
            >
              Write Us
            </Button>
          </li>
        </ul>
      </header>

      {/* Mobile Navigation Overlay */}
      <div
        className={`lg:hidden fixed inset-0 z-40 transition-all duration-300 ${
          isCollapse ? "visible" : "invisible"
        }`}
      >
        {/* Backdrop */}
        <div
          className={`absolute inset-0 bg-black transition-opacity duration-300 ${
            isCollapse ? "opacity-50" : "opacity-0"
          }`}
          onClick={() => setIsCollapse(false)}
          onKeyDown={(e) => {
            if (e.key === "Escape" || e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setIsCollapse(false);
            }
          }}
          tabIndex={isCollapse ? 0 : -1}
          role="button"
          aria-label="Close navigation menu"
        />

        {/* Mobile Menu Panel */}
        <div
          className={`absolute top-0 left-0 h-full w-full bg-white shadow-2xl transform transition-transform duration-300 ease-out ${
            isCollapse ? "translate-x-0" : "translate-x-full"
          }`}
        >
          {/* Header with close button */}
          <div className="flex items-center justify-between p-4 border-b border-gray-100">
            <div className="text-lg font-semibold text-theme-blue">Menu</div>
            <button
              onClick={() => setIsCollapse(false)}
              className="p-2 text-gray-500 transition-colors duration-200 rounded-full hover:text-theme-blue hover:bg-gray-100"
              aria-label="Close menu"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Navigation Items */}
          <div className="h-full p-4 overflow-y-auto">
            <ul className="space-y-2">
              <li>
                <Button
                  className={`${
                    path === "/"
                      ? "active-link bg-purple-50 text-theme-purple"
                      : "text-gray-700"
                  } font-medium text-lg px-4 py-3 no-underline w-full text-left rounded-xl hover:bg-gray-50 transition-all duration-200 flex items-center`}
                  type="link"
                  href="/"
                  onClick={() => setIsCollapse(false)}
                >
                  <svg
                    className="w-5 h-5 mr-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                  Home
                </Button>
              </li>

              <li>
                <Button
                  className={`${
                    path === "/team"
                      ? "active-link bg-purple-50 text-theme-purple"
                      : "text-gray-700"
                  } font-medium text-lg px-4 py-3 no-underline w-full text-left rounded-xl hover:bg-gray-50 transition-all duration-200 flex items-center`}
                  type="link"
                  href="/team"
                  onClick={() => setIsCollapse(false)}
                >
                  <svg
                    className="w-5 h-5 mr-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                  About
                </Button>
              </li>

              <li>
                <div>
                  <Button
                    className={`${
                      path.startsWith("/services")
                        ? "active-link bg-purple-50 text-theme-purple"
                        : "text-gray-700"
                    } font-medium text-lg px-4 py-3 no-underline w-full text-left rounded-xl hover:bg-gray-50 transition-all duration-200 flex items-center justify-between`}
                    type="link"
                    onClick={() => setServicesDropdown(!servicesDropdown)}
                  >
                    <div className="flex items-center">
                      <svg
                        className="w-5 h-5 mr-3"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                      </svg>
                      Services
                    </div>
                    <ChevronDownIcon
                      className={`w-5 h-5 transition-transform duration-200 ${
                        servicesDropdown ? "rotate-180" : ""
                      }`}
                    />
                  </Button>

                  <div
                    className={`mt-2 ml-4 space-y-1 transition-all duration-300 overflow-hidden ${
                      servicesDropdown
                        ? "max-h-96 opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    {servicesLinks.map((item, index) => (
                      <Button
                        key={item.href}
                        className="block w-full px-4 py-2 text-sm text-left text-gray-600 transition-all duration-200 border-l-2 border-transparent rounded-lg hover:bg-purple-50 hover:text-theme-purple hover:border-purple-200"
                        type="link"
                        href={item.href}
                        onClick={handleDropdownLinkClick}
                        style={{
                          animationDelay: `${index * 50}ms`,
                          animation: servicesDropdown
                            ? "slideInFromLeft 0.3s ease-out forwards"
                            : "none",
                        }}
                      >
                        {item.label}
                      </Button>
                    ))}
                  </div>
                </div>
              </li>

              <li>
                <Button
                  className={`${
                    path === "/contact"
                      ? "active-link bg-purple-50 text-theme-purple"
                      : "text-gray-700"
                  } font-medium text-lg px-4 py-3 no-underline w-full text-left rounded-xl hover:bg-gray-50 transition-all duration-200 flex items-center`}
                  type="link"
                  href="/contact"
                  onClick={() => setIsCollapse(false)}
                >
                  <svg
                    className="w-5 h-5 mr-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  Contact
                </Button>
              </li>
            </ul>

            {/* CTA Button */}
            <div className="pt-6 mt-8 border-t border-gray-100">
              <Button
                className="flex items-center justify-center w-full px-6 py-4 text-lg font-medium text-white transition-all duration-300 border-2 border-purple-800 rounded-2xl bg-gradient-to-r from-theme-purple to-blue-600 hover:from-dark-theme-purple hover:to-blue-700 hover:shadow-lg hover:scale-105"
                type="link"
                href="/contact"
                onClick={() => setIsCollapse(false)}
              >
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
                Write Us
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
